import { Section } from 'utils/types/contentfulTypes';

import { DisclaimerSectionProps } from './DisclaimerSection';

export function parseDisclaimerSection(
  section: Section,
): DisclaimerSectionProps {
  const { body } = section;

  if (!body?.raw) return { disclaimer: null };

  return {
    disclaimer: {
      raw: body.raw,
    },
  };
}
